import { $color } from "@/utils/cssVarUtils"
import { radioAnatomy as parts } from "@chakra-ui/anatomy"
import {
  PartsStyleFunction,
  PartsStyleObject,
  SystemStyleFunction,
} from "@chakra-ui/theme-tools"
import { Checkbox } from "./checkbox"

const baseStyleControl: SystemStyleFunction = (props) => {
  const { control = {} } = Checkbox.baseStyle(props)

  return {
    ...control,
    borderWidth: '1px',
    borderRadius: "full",
    _checked: {
      ...(control as any)["_checked"],
      bg: '',
      borderWidth: '1px',
      color: $color('scene-primary-normal'),
      borderColor: 'currentColor',
      _before: {
        content: `""`,
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor",
      },

      _disabled: {
        color: $color('scene-primary-normal'),
        borderColor: 'currentColor',
        opacity: 0.4,
      },
      
      _hover: {
        color: $color('scene-primary-active'),
        borderColor: 'currentColor',
        bg: '',
      }
    },
  }
}

const baseStyle: PartsStyleFunction<typeof parts> = (props) => ({
  label: Checkbox.baseStyle(props).label,
  container: Checkbox.baseStyle(props).container,
  control: baseStyleControl(props),
})

const sizes: Record<string, PartsStyleObject<typeof parts>> = {
  ...Checkbox.sizes,
}

const defaultProps = {
  size: "xs",
}

export const Radio = {
  parts: parts.keys,
  baseStyle,
  sizes,
  defaultProps,
}